// extracted by mini-css-extract-plugin
export default {"loginGoogle":"GoogleButton_loginGoogle__3fq_8 button_button__CHc9H"};